import React from "react";
import { CommunityInformationSectionDetails } from "communities/community-page/_components/community-information-section-details";
import { CommunityTitle } from "communities/community-page/_components/community-title";
import { useCommunityStore } from "communities/community-page/community-context";
import { useTranslation } from "react-i18next";

export function CommunityInformationSection() {
    const { community } = useCommunityStore();
    const { t } = useTranslation();

    return (
        <div className={"flex flex-col justify-between lg:flex-row lg:items-start"}>
            <div className={"flex-1"}>
                <h2 className={"colorSecondary mb-2 md:mb-0"}>
                    {t("communitiesPage.gated")} {t("communitiesPage.community")}:
                </h2>
                <CommunityTitle
                    title={`${community.localized.title} ${t("words.in")} ${community?.geoZone?.address.city}`}
                    delimiter={community.localized.title ? community.localized.title.split(" ").length : 0}
                />
                <div className={" lg:flex justify-between"}>
                    <p className={"md:pr-28 md:flex-1"}>{community.localized.description}</p>

                    <CommunityInformationSectionDetails />
                </div>
            </div>
        </div>
    );
}
